"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CalculateRetireIncomeGapDesktop = CalculateRetireIncomeGapDesktop;
exports.CalculateWillHaveDesktop = CalculateWillHaveDesktop;
var _react = _interopRequireDefault(require("react"));
var _utils = require("../../middleware/utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function CalculateWillHaveDesktop(_ref) {
  var {
    willHaveValue,
    willNeedValue
  } = _ref;
  var percentage = willHaveValue / willNeedValue * 100;
  var greyShadowPercentage = '';
  var verticalHeight = '';
  var invertedText;
  if (percentage >= 100) {
    verticalHeight = 'will-have-bar-color vertical-height100';
  } else if (percentage >= 60 && percentage < 100) {
    greyShadowPercentage = 'vertical-gray-shadow-percent25';
    verticalHeight = 'will-have-bar-color vertical-height75';
  } else if (percentage >= 40 && percentage < 60) {
    greyShadowPercentage = 'vertical-gray-shadow-percent50';
    verticalHeight = 'will-have-bar-color vertical-height50';
  } else if (percentage < 40 && percentage > 0) {
    greyShadowPercentage = 'vertical-gray-shadow-percent75';
    verticalHeight = 'will-have-bar-color vertical-height25';
  } else if (percentage === 0) {
    greyShadowPercentage = 'vertical-gray-shadow-percent100';
    invertedText = true;
  }
  var greyBar = /*#__PURE__*/_react.default.createElement("div", {
    className: "vertical-barchart-bar gray-shadow-bar ".concat(greyShadowPercentage)
  });
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, greyShadowPercentage ? greyBar : '', /*#__PURE__*/_react.default.createElement("div", {
    className: "vertical-barchart-bar basic-bar-setup ".concat(verticalHeight)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "vertical-barchart-text ".concat(invertedText ? 'inverted-text' : '')
  }, ' ', (0, _utils.numberToCurrencyString)((0, _utils.parseCurrencyString)(null, willHaveValue)), " /mo", ' ')));
}
function CalculateRetireIncomeGapDesktop(_ref2) {
  var {
    willNeedValue,
    retireIncomeGapValue,
    willHaveValue
  } = _ref2;
  var percentage = willHaveValue / willNeedValue * 100;
  var greyShadowPercentage = '';
  var verticalHeight = '';
  if (willHaveValue > willNeedValue) {
    verticalHeight = 'gray-shadow-bar vertical-gray-shadow-percent100 inverted-bar-col-text-alignment vertical-height100';
  } else if (percentage >= 100) {
    verticalHeight = 'retire-income-gap-bar-color inverted-bar-col-text-alignment vertical-height100';
  } else if (percentage >= 60 && percentage <= 100) {
    greyShadowPercentage = 'vertical-gray-shadow-percent75';
    verticalHeight = 'retire-income-gap-bar-color inverted-bar-col-text-alignment vertical-height25';
  } else if (percentage >= 40 && percentage < 60) {
    greyShadowPercentage = 'vertical-gray-shadow-percent50';
    verticalHeight = 'retire-income-gap-bar-color inverted-bar-col-text-alignment vertical-height50';
  } else if (percentage < 40 && percentage > 0) {
    greyShadowPercentage = 'vertical-gray-shadow-percent25';
    verticalHeight = 'retire-income-gap-bar-color inverted-bar-col-text-alignment vertical-height75';
  } else if (percentage === 0) {
    verticalHeight = 'retire-income-gap-bar-color inverted-bar-col-text-alignment vertical-height100';
  }
  var greyBar = /*#__PURE__*/_react.default.createElement("div", {
    className: "vertical-barchart-bar gray-shadow-bar ".concat(greyShadowPercentage)
  });
  var gapAsNumber = (0, _utils.parseCurrencyString)(null, retireIncomeGapValue);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "vertical-barchart-bar basic-bar-setup ".concat(verticalHeight)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "inverted-vertical-barchart-text"
  }, ' ', gapAsNumber < 0 ? '$0' : (0, _utils.numberToCurrencyString)((0, _utils.parseCurrencyString)(null, retireIncomeGapValue)), ' ', "/mo", ' ')), greyShadowPercentage ? greyBar : '');
}